import styled from 'styled-components';

type DateDropdownFieldStyleType = {
  flatSide: 'left' | 'right';
};

export const Fotter = styled.div`
  display: flex;
`;

export const Box = styled.div`
  &:not(&:last-of-type) {
    padding-bottom: 30px;
  }
`;

export const Divider = styled.div`
  border-bottom: 1px solid #ebebeb;
  margin-top: 30px;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
`;

export const TwoColumnsContainer = styled.div`
  width: 50%;
  display: flex;
`;

export const DateDropdownFieldContainer = styled.div<DateDropdownFieldStyleType>`
  width: 50%;

  button {
    border-top-${(props) => props.flatSide}-radius: 0px;
    border-bottom-${(props) => props.flatSide}-radius: 0px;
  }

  & + & {
    margin-left: 1px;
  }
`;

export const FieldContainer = styled.div`
  width: 50%;
  marign-right: 4px;

  #dropdown-area {
    padding-right: 4px;
  }
`;

export const DropDownContainer = styled.div`
  width: 50%;
  &:not(&:last-of-type) {
    margin-right: 2px;
  }
`;

export const GrayText = styled.span`
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const BoldText = styled.span`
  font-weight: 600;
`;
